import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activedHead: 'ins',
    isAdmin: false
  },
  mutations: {
    changeHead(state, page) {
      state.activedHead = page
    },
    userIsAdmin(state) {
      state.isAdmin = true
    }
  },
  actions: {
  },
  modules: {
  }
})
